import ApprovalClient from '@financial/sbill/dist/approvals/ApprovalClient'
import {ApprovalResult, ApproveArgs, ReservationPayload} from '@financial/sbill/dist/approvals/types'

import {getClient} from '@web/helpers/sbill'

/** 빌링 결제 프로세스 */
export const createBillingProcessor = (reservationPayload: ReservationPayload, payload: ApproveArgs['payload']) => {
    let client: Maybe<ApprovalClient>
    const prevOverflowY = document.body.style.overflowY
    const handleDone = () => {
        document.body.style.overflowY = prevOverflowY
        client?.clear()
    }
    return new Promise<ApprovalResult>((resolve, reject) => {
        try {
            client = getClient(reservationPayload)

            document.body.style.overflowY = 'hidden'

            client.approve({
                payload,
                callback: {
                    onApproved: (approveArgs) => {
                        handleDone()
                        resolve(approveArgs)
                    },
                },
            })
        } catch (e) {
            handleDone()
            reject(e)
        }
    })
}
